//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'NetworkErrorScreen',
  props: {
    errorMessages: {
      type: Array
    }
  },
  data: function data() {
    return {
      isRefreshing: false
    };
  },
  methods: {
    retry: function retry() {
      var _this = this;

      this.$emit('retry');
      this.isRefreshing = true;
      this.$xp.network.recheckIsOnline();
      setTimeout(function () {
        _this.isRefreshing = false;
      }, 1000);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-network-error-screen" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-network-error-screen__message" },
      [
        !_vm.errorMessages
          ? _c("p", [_vm._v(_vm._s(_vm.$t("global.connectionErrorMessage")))])
          : _vm._l(_vm.errorMessages, function(message, index) {
              return _c("p", { key: index }, [_vm._v(_vm._s(message))])
            }),
        _vm._v(" "),
        _c("button", { on: { click: _vm.retry } }, [
          _c("div", {
            class: { reloadDouble: true, "is-refreshing": _vm.isRefreshing }
          })
        ])
      ],
      2
    )
  ])
};
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "c-network-error-screen__logo" }, [
      _c("img", {
        attrs: {
          alt: "Xpedeo",
          src:
            "data:image/svg+xml;base64,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"
        }
      })
    ])
  }
];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
